import angular from "angular";

import { moduleName as recordsModuleName } from "../../../records";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import { machineConfigurationConfig } from "./machineConfiguration";
import { machineDetailTabComponentConfigure } from "./configureMachineDetailTabs";
import { changesConfig } from "./changes";
import { machineConfig } from "./machine";
import { machineGameConfig } from "./machineGameConfiguration";
import { machineProgressiveLevelConfig } from "./machineProgressiveLevel";

import { vsModuleName as lookupConfigModuleName } from "./lookup/module";
import { machineEpromConfigurationConfig } from "./machineEpromConfigurations";
import { configMealLogMachineTab } from "../../../machines.mealLog/components/entryList/configMealLogMachineTab";

export const vsModuleName = "SlotTrak.Machines.Config";

angular
  .module(vsModuleName, [
    recordsModuleName,
    shareMachineModuleName,
    lookupConfigModuleName,
  ])
  .config(machineConfigurationConfig)
  .config(machineDetailTabComponentConfigure)
  .config(configMealLogMachineTab)
  .config(changesConfig)
  .config(machineConfig)
  .config(machineGameConfig)
  .config(machineProgressiveLevelConfig)
  .config(machineEpromConfigurationConfig);
